export default "__VITE_ASSET__C5rg_LNR__"